module.exports = __webpack_public_path__ + "img/c4.2cdb3cfe.png";